/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://n5nzg4mnorggxipc46ss226db4.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-2:ab63a702-1525-4900-a5ca-6577ae8d3caa",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_xpefe8RJI",
    "aws_user_pools_web_client_id": "4lrcsqi2voqdkntn7q9mgqffb9",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "sourcingv2webb711330d186443c7b9e43045caf0c896220431-master",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
